"use strict";

var _interopRequireDefault = require("D:/CRM/Client2026/node_modules/@babel/runtime/helpers/interopRequireDefault.js");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.add = add;
exports.all = all;
exports.allSelects = allSelects;
exports.default = void 0;
exports.del = del;
exports.edit = edit;
exports.generateContractNo = generateContractNo;
exports.isExistByContactNo = isExistByContactNo;

var _request = _interopRequireDefault(require("@/utils/request"));

function all(custId) {
  return (0, _request.default)({
    url: 'api/contract?custId=' + custId,
    method: 'get'
  });
}

function allSelects(custId) {
  return (0, _request.default)({
    url: 'api/contract?custId=' + custId + '&page=0&size=50',
    method: 'get'
  });
}

function add(data) {
  return (0, _request.default)({
    url: 'api/contract',
    method: 'post',
    data: data
  });
}

function del(ids) {
  return (0, _request.default)({
    url: 'api/contract/',
    method: 'delete',
    data: ids
  });
}

function edit(data) {
  return (0, _request.default)({
    url: 'api/contract',
    method: 'put',
    data: data
  });
}

function isExistByContactNo(data) {
  return (0, _request.default)({
    url: 'api/contract/isExistByContactNo?contractNo=' + data.contractNo,
    method: 'get'
  });
}

function generateContractNo(data) {
  return (0, _request.default)({
    url: 'api/contract/generateContractNo?type=' + data.type,
    method: 'get'
  });
}

var _default = {
  add: add,
  edit: edit,
  del: del,
  all: all,
  isExistByContactNo: isExistByContactNo,
  generateContractNo: generateContractNo,
  allSelects: allSelects
};
exports.default = _default;